import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useToken } from "../../../Component/Context/useToken";
import { fontStyles } from "../../../Component/style/common_font";
import {
  CenterView,
  Icon,
  RowView,
  RowView2,
} from "../../../Component/style/common_style";
import Footer from "../../../Component/UI/Footer";
import Layout_user from "../../../Component/UI/Layout_user";
import Notify from "./Notify";
import UserLiveList from "./UserLiveList";
import SideBar from "./Component/SideBar";
import LoginModal from "../Sign/Modal/LoginModal";
import Block from "../Live/modal/Block";
import url from "../../../Component/server";
import decodeToken from "../../../Component/tool/jwt_decode";
import Tuto from "./Tuto";

const Home = () => {
  const Navigate = useNavigate();

  const { logout } = useToken();

  const [isLogin, setisLogin] = useState(false);
  const [loading, setLoading] = useState(false);
  // 스토어 검색
  const [text, setText] = useState("");
  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value);
  };
  const [blockModal, setBlockModal] = useState(false);
  const handleBlockModal = () => {
    setBlockModal(!blockModal);
  };
  const [ban_popup, setBan_popup] = useState("");

  const [bannerImg, setBannerImg] = useState("test");
  const [bannerUrl, setBannerUrl] = useState("");

  const [loginModalVisible, setLoginModalVisible] = useState(false);
  const handleLoginModalVisible = () => {
    setLoginModalVisible(!loginModalVisible);
  };

  useEffect(() => {
    if (localStorage.getItem("key") !== null) {
      setisLogin(true);
      setLoading(false);
    }
  }, [isLogin]);

  // 토큰 만료시간 검사
  const refreshT = localStorage.getItem("key") || null;

  useEffect(() => {
    if (refreshT) {
      const now = new Date();
      const originalExp = new Date(decodeToken(refreshT).exp * 1000);
      const exp = new Date(
        originalExp.getFullYear(),
        originalExp.getMonth(),
        originalExp.getDate(),
        1,
        0,
        0
      );

      if (now > exp) {
        alert("로그인 최대 연장시간이 지났습니다. 재로그인 해주세요.");
        logout();
      }
    }
  }, []);

  useEffect(() => {
    // 우클릭 금지
    const originalOnContextMenu = document.oncontextmenu;
    document.oncontextmenu = function () {
      return false;
    };

    return () => {
      document.oncontextmenu = originalOnContextMenu;
    };
  }, []);

  // 사이드바
  const [sideBarVisible, setSideBarVisible] = useState(false);
  const [sidebarOn, setSidebarOn] = useState(false);
  const handleSidebarToggle = () => {
    setSidebarOn(!sidebarOn);
    setSideBarVisible(true);
  };

  return (
    <Layout_user>
      <div style={{ position: "relative", overflow: "hidden" }}>
        {sideBarVisible && (
          <SideBar
            handleSidebarToggle={handleSidebarToggle}
            isVisible={sidebarOn}
          />
        )}
        <Topbar>
          <RowView>
            <Logo src={require("../../../Image/Logo_Text.png")} />
          </RowView>
          {loading ? (
            <div className="loading" />
          ) : (
            <RowView2>
              {/* <Icon
                className="btn"
                style={{ marginRight: 10 }}
                src={require("../../../Image/ic_find_white.png")}
                onClick={() => {
                  Navigate("/search");
                }}
              /> */}
              {isLogin ? (
                <Btn onClick={() => logout("")}>로그아웃</Btn>
              ) : (
                <Btn onClick={handleLoginModalVisible}>로그인</Btn>
              )}
              <Icon
                className="btn"
                src={require("../../../Image/ic_hamburger_white.png")}
                onClick={handleSidebarToggle}
              />
            </RowView2>
          )}
        </Topbar>

        <Notify img={bannerImg} url={bannerUrl} />
        <Tuto />

        <Search>
          찾으시는 스토어가 있다면?
          <SearchDiv>
            <Icon src={require("../../../Image/ic_find_white2.png")} />
            <SearchInput
              type="text"
              placeholder="스토어명을 입력해주세요."
              value={text}
              onChange={handleTextChange}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  Navigate("/search", { state: { searchText: text } });
                }
              }}
            />
          </SearchDiv>
        </Search>
        <UserLiveList
          isLogin={isLogin}
          key={isLogin ? "loggedIn" : "loggedOut"}
        />

        <Footer />
        <LoginModal
          handleModal={handleLoginModalVisible}
          visible={loginModalVisible}
          setTryLogin={setisLogin}
          setLoading={setLoading}
          setBlockModal={setBlockModal}
        />
        <Block
          visible={blockModal}
          handleModal={handleBlockModal}
          ban_popup={ban_popup}
        />
      </div>
    </Layout_user>
  );
};

export default Home;

const Topbar = styled(RowView)`
  z-index: 99;
  box-sizing: border-box;
  /* position: absolute; */
  width: 100%;
  top: 0;
  max-width: 500px;
  background-color: #2d2d2d;
  padding: 15px;
  padding-left: 0px;

  div.loading {
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    border: 3px solid #7955f0;
    border-top-color: #9c9c9c;
    border-radius: 100%;
    animation: spin 1s ease-in-out infinite;
  }
  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Btn = styled(CenterView)`
  margin-right: 10px;
  padding: 0px 15px;
  ${fontStyles.semiBold}
  cursor: pointer;
  @media ${({ theme }) => theme.small} {
    font-size: 15px;
  }
`;

const Logo = styled(Icon)`
  height: 44px;
  margin-right: 5px;
  @media ${({ theme }) => theme.small} {
    height: 2rem;
  }
  border-radius: 4px;
`;

const SearchDiv = styled.div`
  flex-direction: row;
  display: flex;
  background-color: #3a3939;
  border-radius: 8px;
  border: 1px solid #474747;
  width: 100%;
  height: 50px;
  justify-self: center;
  align-items: center;
  justify-content: flex-start;
  padding: 12px;
  box-sizing: border-box;
`;

const SearchInput = styled.input`
  margin-left: 10px;
  font-size: 16px;
  color: #ffffff;
  background-color: transparent;
  border: none;
  outline: none;
  width: 100%;
`;

const Search = styled.div`
  font-size: 18px;
  font-family: var(--font-Pretendard-Bold);
  margin-top: 20px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
